<div
  class="success-user-group d-flex flex-row align-items-center h-100 w-100 justify-content-center"
>
  <div
    class="content d-flex flex-column justify-content-center align-items-center align-items-lg-start w-75 pr-lg-5 pl-lg-5"
  >
    <p class="text-lg-left text-center mb-4 headingOne">
      {{ 'USER_GROUP' | translate }}
    </p>

    <div class="tick-circle mt-3 mb-3">
      <div class="outer-circle">
        <div class="inner-circle">
          <span class="inside-content ml-4">
            <svg
              class="mt-4"
              xmlns="http://www.w3.org/2000/svg"
              width="44.125"
              height="36.103"
              viewBox="0 0 44.125 36.103"
            >
              <path
                id="checkmark-outline"
                d="M687.927-12.424a2.868,2.868,0,0,1-2.065-.879L673.7-25.98a2.006,2.006,0,0,1,.059-2.836,2.006,2.006,0,0,1,2.836.059L687.87-17l25.858-30.806a2.005,2.005,0,0,1,2.826-.247,2.006,2.006,0,0,1,.247,2.826L690.12-13.447a2.867,2.867,0,0,1-2.1,1.021Z"
                transform="translate(-673.144 48.527)"
                fill="#54BF1D"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>

    <p class="paragraph-text mt-3">
      {{ (isEditMode ? "ADDED" : "UPDATED") | translate }}
    </p>
  </div>
</div>
